export class WalletOfferRequestDto {

    locationCode: number;
    amount: number;
    email: string;
    customerCode: string;
    transactionPoint: string;
    applicableCustomer: string;
    transactionType: string;

}
